// PreorderEtaBadge — renders "ARRIVES <from> - <to>" for a preorder ETA.
// Returns null on empty / missing / partial window (spec: silent on absence).
//
// Consumed by /p/:handle PDP between the inventory chip and variant selector.
//
// Path B integration: the ETA window is computed by the shared helper in
// frontend/src/lib/preorder.js (getPreorderWindow) — this component does NOT
// duplicate that data.

import './PreorderEtaBadge.css';

function toDateOrNull(v) {
        if (v == null) return null;
        if (v instanceof Date) return isNaN(v.getTime()) ? null : v;
        const d = new Date(v);
        return isNaN(d.getTime()) ? null : d;
}

function fmt(d) {
        // e.g. "18 AUG" — locale-independent, uppercase, day + short-month.
        const day = d.getDate();
        const mon = d.toLocaleString('en-US', { month: 'short' }).toUpperCase();
        return `${day} ${mon}`;
}

export default function PreorderEtaBadge({ etaWindow }) {
        if (!etaWindow) return null;
        const from = toDateOrNull(etaWindow.from ?? etaWindow.start);
        const to = toDateOrNull(etaWindow.to ?? etaWindow.end);
        if (!from || !to) return null;
        return (
                <div data-testid="preorder-eta-badge">
                        <p className="preorder-eta-badge">
                                DISPATCHES {fmt(from)} - {fmt(to)}
                        </p>
                        <p data-testid="preorder-eta-note" className="preorder-eta-note">
                                If you order today · window updates daily
                        </p>
                </div>
        );
}
